import { footerLinks, footerIntro, siteInfo } from '@/mocks/homeData';

export default function Footer() {
  const scrollToSection = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-xl text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed mb-5">
              {footerIntro}
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide uppercase">
              <a href="#footer" className="cursor-pointer">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(link.href);
                    }}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide uppercase">合作伙伴</h4>
            <p className="text-sm text-background-400">更多合作伙伴即将入驻，敬请期待。</p>
            <div className="flex gap-3 mt-4">
              <span className="inline-block px-3 py-1.5 bg-background-800 text-background-300 rounded-full text-xs">品牌入驻</span>
              <span className="inline-block px-3 py-1.5 bg-background-800 text-background-300 rounded-full text-xs">商务合作</span>
              <span className="inline-block px-3 py-1.5 bg-background-800 text-background-300 rounded-full text-xs">广告投放</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide uppercase">关注我们</h4>
            <div className="flex gap-3">
              <a href="#footer" className="w-10 h-10 flex items-center justify-center bg-background-800 hover:bg-primary-600 rounded-lg transition-colors cursor-pointer">
                <i className="ri-weibo-line text-background-300 text-lg"></i>
              </a>
              <a href="#footer" className="w-10 h-10 flex items-center justify-center bg-background-800 hover:bg-primary-600 rounded-lg transition-colors cursor-pointer">
                <i className="ri-wechat-line text-background-300 text-lg"></i>
              </a>
              <a href="#footer" className="w-10 h-10 flex items-center justify-center bg-background-800 hover:bg-primary-600 rounded-lg transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-background-300 text-lg"></i>
              </a>
              <a href="#footer" className="w-10 h-10 flex items-center justify-center bg-background-800 hover:bg-primary-600 rounded-lg transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-background-300 text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} {siteInfo.name} · 51吃瓜黑料入口一二三 · 免费黑料入口 · 保留所有权利
          </p>
          <div className="flex gap-5">
            <a href="#footer" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">隐私政策</a>
            <a href="#footer" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">用户协议</a>
            <a href="#footer" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}